import idOrSection from "./idOrSection"

interface URLPattern {
	host: string
	pathPatternArray: string[]
}

function isNotUndefined<T>(value: T | undefined): value is T {
	return typeof value !== "undefined"
}

// if twitter were using Jam we'd want the comments to appear on any url that's like
// twitter.com/*/tweet/* rather than on a specific user/tweet
// so this takes a host and pathname and returns a path array where each section of the path is either a phrase to match or a *

export default function createUrlPattern(
	host: string,
	pathname: string,
): URLPattern {
	// host includes port number if included
	const path = pathname.split("/")
	const pathPatternArray = path.map((subpath) => {
		if (subpath.length === 0) return

		const { type } = idOrSection(subpath)
		if (type === "section") return subpath
		return "*"
	})

	const filtered = pathPatternArray.filter(isNotUndefined)

	return { host, pathPatternArray: filtered }
}
